<template>
  <div style="overflow: hidden;">
    <div
      v-if="mfg"
      class="row text-center">
      <!-- Dropship vendor logo -->
      <img
        :src="mfg.super_buyline ? mfg.logo2 : mfg.logo"
        class="img-fluid p-0"
        style="max-width: 10em; margin: 0 auto;"/>
      <div class="col-12">
        <h5>
          Vendor Notes
        </h5>
        <ul style="padding: 0px; list-style-type: none;">
          <li v-for="n in vendorNotes">
            {{ n.customerDisplayText }}
          </li>
        </ul>
      </div>
      <div v-if="showAgree">
        <div
          v-if="!agreed"
          class="col-12 text-center">
          <div class="mb-3">
            <i class="fa fa-exclamation-triangle text-warning"/>
            <strong class="ms-1">
              Dropship Order Terms: NET 30
            </strong>
          </div>
          <div class="text-muted">
            <small>
              I have reviewed and agree to
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#dropshipPolicyModal"
                style="font-weight: bold;">
                Lancaster’s Dropship Policy
              </a>
              including that all sales are final and not eligible for return. I understand that I am responsible for reviewing my order confirmation, following all procedures for damages or cancellations, and may be liable for the full order if policies are not followed.
            </small>
          </div>
          <button
            class="btn btn-primary mt-3"
            type="button"
            @click="toggleAgreed">
            I Agree
          </button>
        </div>
        <div
          v-else
          class="col-12 text-center">
          <i class="fa fa-check-circle text-success animate__animated animate__bounceIn animate__faster"/>
          Customer has agreed to the Lancaster's & Manufacturer’s terms and conditions.
          <br>
          Orders that do not meet minimum order thresholds may be cancelled.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  
  // Initialize
  const props = defineProps(['mfg', 'showNotes', 'showTimes', 'showAgree']);
  const emit = defineEmits(['vendorNotesAgreed'])
  const store = useStore()

  // Data
  const agreed = ref(false)

  const toggleAgreed = ()=>{
    agreed.value = !agreed.value
    if(agreed.value){
      emit('vendorNotesAgreed')
    }
  }

  /* Computed */
  
  // Notes
  const vendorNotes = computed(()=>{
    if(props.mfg?.details?.vendor_mins){
      let notes = []
      const data = _.filter(props.mfg.details.vendor_mins, v => v.company == company.value)
      data.forEach(d=>{
        notes.push(_.pick(d, ['minFunction', 'customerDisplayText']))
      })
      return notes.length ? notes : null
    }
    return null
  })

  // Company
  const company = computed(()=>{
    return store.getters.sessionCompany
  })
</script>